/**
 * WorkTypeDropdown
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Components
import WorkTypeOptions from '../../../WorkTypeOptions';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Workspaces
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';

interface Props {
    clearPageOnChange?: boolean;
    updateQueryString: Function;
    workTypes?: string | string[];
    multiple: boolean;
}

export class WorkTypeDropdown extends React.Component<Props> {
    handleChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { value: number }
    ) => {
        const { clearPageOnChange } = this.props;
        this.props.updateQueryString({
            ...(clearPageOnChange ? { page: undefined } : {}),
            workTypes: data.value || undefined,
            selectedEvent: undefined
        });
    };

    render() {
        const { workTypes, multiple } = this.props;
        return (
            <WorkTypeOptions valueIsString>
                {options => (
                    <Dropdown
                        placeholder="All Types"
                        search
                        selection
                        value={workTypes || null}
                        clearable
                        selectOnBlur={false}
                        options={options}
                        onChange={this.handleChange}
                        lazyLoad
                        multiple={multiple}
                        closeOnChange
                        fluid
                    />
                )}
            </WorkTypeOptions>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    workTypes: makeSelectQueryStringValue('workTypes')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(WorkTypeDropdown);
